import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import * as groupApi from '../../api/app/groupApi';
import { ApiError } from '../../components/core/ApiError/ApiError';
import { Loader } from '../../components/core/Loader/Loader';
import { SelectBoxAutocomplete } from '../../components/core/SelectBox/SelectBoxAutocomplete';
import { useTranslation } from '../../contexts/translation';
import { GroupInput } from '../../types/app/group.types';
interface Props {
  setSelectedGroup: any;
  storageGroup: any;
  setStorageGroup: any;
}

export function AssetListGroupSearch({ setSelectedGroup, storageGroup, setStorageGroup }: Props) {
  const { t } = useTranslation();
  const {
    formState: { errors },
    control,
    setValue,
  } = useForm<GroupInput>();

  const {
    data: groupList,
    isLoading,
    isError,
  } = useQuery<GroupInput[]>('groupList', groupApi.getGroupList, {
    onSuccess: (res) => {
      res.push({ id: null, name: t('page.asset.dropdown-title-group-empty-option') });
    },
  });

  useEffect(() => {
    if (!storageGroup) return;
    setValue('id', storageGroup);
  }, []);

  if (isError) return <ApiError />;
  if (isLoading || !groupList) return <Loader />;

  return (
    <>
      <form noValidate>
        <Grid container spacing={1}>
          <Grid item xs={12} md={3} mb={3}>
            <SelectBoxAutocomplete
              label={t(`page.asset.dropdown-title-group`)}
              items={groupList}
              onChange={(value: any) => {
                setSelectedGroup(value);
                setStorageGroup(value);
              }}
              valueKey={'id'}
              labelKey={'name'}
              controllerProps={{
                name: 'id',
                control: control,
              }}
              errors={errors}
              readOnly={false}
            />
          </Grid>
        </Grid>
      </form>
    </>
  );
}
